import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../overlay/Dialog';
import OverlayController from '../overlay/OverlayController';
import PluginsManager from '../plugins/PluginsManager';
import mutations from '../../graphql/mutations';
import {Tabs, Tab} from 'material-ui/Tabs';
import { compose } from 'react-apollo';
import './CreateItemDialog.css';

class CreateItemDialog extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            plugins: this.filteredPluginsFromProps(props)
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            plugins: this.filteredPluginsFromProps(nextProps)
        });
    }

    filteredPluginsFromProps(props) {
        return props.project.plugins.filter(plugin => {
            return 'PluginItemCreateView' in PluginsManager.getPluginByTypeId(plugin.typeId);
        });
    }

    getPluginItemCreateViewByPlugin(projectPlugin) {
        let plugin = PluginsManager.getPluginByTypeId(projectPlugin.typeId);
        let PluginItemCreateView = plugin.PluginItemCreateView;
        return <PluginItemCreateView
            configuration={projectPlugin.configuration}
            createItem={this.onPluginItemCreate.bind(this)}
        />
    }

    onPluginItemCreate(item, callback) {
        let clientId = item.clientId || null;
        let data = item.data || null;
        let tags = item.tags || null;
        let promise = this.props.createItem(this.props.project.id, clientId, data, tags);
        if (callback && typeof callback === "function") {
            promise.then(item => {
                callback(null, item)
            }).catch(error => {
                callback(error, null)
            });
        } else {
            return promise;
        }
    }

    render() {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
        ];
        return (
            <Dialog showTitleBar={true} title="Create Item" actions={actions} className="createItemDialog">
                <Tabs inkBarStyle={{height: 4, marginTop: -4}} contentContainerClassName="createItemDialogTabsContentContainer">
                    {this.state.plugins.map((plugin, index) => (
                        <Tab label={plugin.title} value={index} key={index}>
                            <div className="createItemDialogContentWrapper">
                                {this.getPluginItemCreateViewByPlugin(plugin)}
                            </div>
                        </Tab>
                    ))}
                </Tabs>
            </Dialog>
        );
    }

}

CreateItemDialog.propTypes = {
    project: PropTypes.object.isRequired
};
CreateItemDialog.defaultProps = {};

export default compose(
    mutations.createItemMutationHoc
)(CreateItemDialog);



// WEBPACK FOOTER //
// ./src/components/item/CreateItemDialog.js